import { ReactComponent as SvgChevron } from '@img/icons/nav-arrow-right.svg';
import React from 'react';
import S from '../../UmbracoForm.styles';
const DropDownList = React.forwardRef(({ field, error, ...otherProps }, ref) => {
    return (React.createElement(S.Field, { className: error?.message && 'invalid' },
        React.createElement(S.Label, { htmlFor: field.alias, "data-sr-only": true },
            field.caption,
            field.required && React.createElement(React.Fragment, null, "*")),
        React.createElement(S.SelectWrapper, null,
            React.createElement(S.Select, { ref: ref, id: field.alias, placeholder: field.placeholder, required: field.required, ...otherProps },
                React.createElement("option", { value: "" }, field.placeholder ? field.placeholder : field.caption),
                field.values?.map((value, index) => (React.createElement("option", { key: `option-${index}`, value: value.value }, value.caption)))),
            React.createElement(S.Arrow, null,
                React.createElement(SvgChevron, null))),
        error && React.createElement(S.Error, null, error.message)));
});
DropDownList.displayName = 'DropDownList';
export default DropDownList;
